import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/Administration/designations/form'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { v3_add_designation } from '../../../actions/v3/designation'
const Add = (props) => {
    const onSubmit = (model) => {
        v3_add_designation(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listDesignation.url)
            }
            else {
                toast.error(res.error)
            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Create Designation'}>
                <Form
                    // title={'Add Designation'}
                    onSubmit={onSubmit}
                    buttonName={'Create Designation'}
                />
            </Layout>

        </React.Fragment>
    )
}

export default Add